import { create } from 'zustand'

export interface TaskToolDialogState {
  isOpen: boolean
  taskId: string | null
  projectId: string | null
  toolId: string | null
  readonly?: boolean
  refetchBoard?: (() => void) | null
}

export interface TaskToolDialogActions {
  openDialog: (params: {
    taskId: string
    projectId: string
    toolId: string
    readonly?: boolean
    refetchBoard?: () => void
  }) => void
  closeDialog: () => void
}

export type TaskToolDialogStore = TaskToolDialogState & TaskToolDialogActions

const initialState: TaskToolDialogState = {
  isOpen: false,
  taskId: null,
  projectId: null,
  toolId: null,
  readonly: false,
  refetchBoard: null,
}

export const clearTaskToolCache = () => {
  try {
    localStorage.removeItem('get-task-tool-part-data')
    localStorage.removeItem('get-task-tool-part-data-with-params')
    localStorage.removeItem('task-tool-part-template-table-history')
    localStorage.removeItem('task-tool-part-template-table')
  } catch (error) {
    console.warn('Error clearing task tool cache:', error)
  }
}

export const useTaskToolDialogStore = create<TaskToolDialogStore>((set, get) => ({
  ...initialState,

  openDialog: ({ taskId, projectId, toolId, readonly = false, refetchBoard }) =>
    set({ isOpen: true, taskId, projectId, toolId, readonly, refetchBoard }),

  closeDialog: () => {
    clearTaskToolCache()
    set({ isOpen: false, taskId: null, projectId: null, toolId: null, readonly: false, refetchBoard: null })
  },
}))
